// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__-cto7","list":"Navigation_list__VZsJU","item":"Navigation_item__2S1ji","link":"Navigation_link__13qe6","active":"Navigation_active__1vK5v"};